import * as React from "react";
import { CSSProperties } from "react";
import { BoxProps, getDataProps, Row } from "@stenajs-webui/core";
import styles from "./StickySummaryFooter.module.css";
import cx from "classnames";

export interface StickySummaryFooterProps extends BoxProps {}

export const StickySummaryFooter: React.FC<StickySummaryFooterProps> = ({
  zIndex = 100,
  className,
  style,
  ...props
}) => {
  return (
    <div
      className={cx(styles.stickySummaryFooter, className)}
      {...getDataProps(props)}
      style={{ zIndex, ...style } as CSSProperties}
    >
      <Row
        indent={2}
        spacing={2}
        alignItems={"center"}
        justifyContent={"space-between"}
        {...props}
      />
    </div>
  );
};
